import { Button, Flex, Input, Spinner, Text, VStack } from "@chakra-ui/react";
import { FC } from "react";
import { RoomMetadata } from "../auto-generated-clients/content-delivery-client-v3.generated";
import { NavigationBarItem } from "./NavigationBarItem";
import { Company } from "../auto-generated-clients/companydata-client-v2.generated";
import { NavigationBarCompanyItem } from "./NavigationBarCompanyItem";
import { LuX } from "react-icons/lu";

type NavigationBarProps = {
  rooms: RoomMetadata[] | undefined;
  companies: Company[] | undefined;
  selectedRoom: RoomMetadata | undefined;
  setSelectedRoom: (room: RoomMetadata | undefined) => void;
  selectedCompany: Company | undefined;
  setSelectedCompany: (company: Company | undefined) => void;
  handleSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  resetSearch: () => void;
  isLoading: boolean;
};

export const NavigationBar: FC<NavigationBarProps> = ({
  companies,
  selectedCompany,
  setSelectedCompany,
  rooms,
  selectedRoom,
  setSelectedRoom,
  handleSearch,
  resetSearch,
  isLoading,
}) => {
  const onCompanyClick = (company: Company) => {
    setSelectedCompany(company);
    resetSearch();
  };
  const onRoomClick = (room: RoomMetadata) => {
    setSelectedRoom(room);
  };

  const onResetClick = () => {
    setSelectedCompany(undefined);
    setSelectedRoom(undefined);
  };

  const renderRooms = () =>
    rooms?.map((room) => {
      const isSelected =
        selectedRoom?.contentMetadataId === room.contentMetadataId;

      return (
        <NavigationBarItem
          key={room.roomMetadataId}
          room={room}
          selected={isSelected}
          onRoomClick={onRoomClick}
        />
      );
    });

  const renderCompanies = () =>
    companies?.map((company) => {
      const isSelected = selectedCompany?.companyId === company.companyId;

      return (
        <NavigationBarCompanyItem
          key={company.companyId}
          company={company}
          selected={isSelected}
          onCompanyClick={onCompanyClick}
        />
      );
    });

  return (
    <VStack
      bg={"secondary.0"}
      height={"100%"}
      width={"md"}
      overflowY={"auto"}
      overflowX={"hidden"}
      marginTop={1}
    >
      <VStack
        marginTop={4}
        px={8}
        width={"full"}
      >
        {selectedCompany && (
          <Flex
            justifyContent={"space-between"}
            width={"full"}
          >
            <Text
              color={"text.1"}
              fontSize={"md"}
              fontWeight={"600"}
            >
              {selectedCompany.friendlyName}
            </Text>
            <Button
              variant={"ghost"}
              boxSize={6}
              onClick={onResetClick}
              color={"text.1"}
            >
              <LuX />
            </Button>
          </Flex>
        )}

        <Flex width={"full"}>
          <Input
            placeholder="search"
            bg={"defaultBackground"}
            size={"sm"}
            onChange={handleSearch}
          />
        </Flex>
      </VStack>
      <VStack
        bg={"secondary.0"}
        height={"100%"}
        px={4}
        width={"full"}
        overflowY={"auto"}
        gap={0}
      >
        {isLoading && <Spinner color={"primary.3"} />}
        {!selectedCompany ? renderCompanies() : renderRooms()}
      </VStack>
    </VStack>
  );
};
